<template>
  <v-container class="account-info" v-if="currentUser">
    <v-row class="account-info-title">
      <v-col>
        {{ $t('my_account.account_info') }}
      </v-col>
    </v-row>
    <v-row v-if="!editing" class="account-info-display-form">
      <v-col cols="12" md="8" order="2" order-md="1">
        <!--            <v-col cols="12" lg="12" order="2" order-lg="1">-->
        <v-row>
          <v-col cols="12">
            <v-text-field :label="$t('my_account.serial_no')"
                          readonly
                          hide-details
                          :value="currentUser.serial_no.toString().padStart(6, '0')"
                          class="input-no-underline"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field :label="$t('register.salutation')"
                          readonly
                          hide-details
                          :value="$t(`salutation.${currentUser.salutation}`)"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field :label="$t('my_account.name_en')"
                          readonly
                          hide-details
                          :value="`${currentUser.surname_en}, ${currentUser.given_name_en}`"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field :label="$t('my_account.name_zh')"
                          readonly
                          hide-details
                          :value="(currentUser.surname_zh + currentUser.given_name_zh) || ' '"></v-text-field>
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field :label="$t('register.company')"
                          readonly
                          hide-details
                          :value="(currentUser.sasv && currentUser.sasv.company && currentUser.sasv.company.name) || ' '"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field :label="$t('my_account.mobile')"
                          readonly
                          hide-details
                          :value="currentUser.mobile || ' '"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('register.email')"
                          readonly
                          hide-details
                          :value="currentUser.email"></v-text-field>
          </v-col>
          <v-col class="text-right" cols="12" md="6">
            <v-btn rounded
                   color="primary"
                   @click="changeAccountEmail">
              <v-icon>mdi-pencil</v-icon>
              <span class="font-size-35">{{ $t('my_account.change_email') }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch dense
                      :label="$t('my_account.receive_promotional_email')"
                      hide-details
                      v-model="currentUser.receive_promotional_email"
                      @change="onReceivePromotionalEmailInput"></v-switch>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="12" md="4" order="1" order-md="2">
        <v-row class="text-center">
          <v-col class="account-info-membership-card-container">
            <qrcode :value="currentUser.token" :options="{ width: 200 }" class="account-info-membership-qrcode"></qrcode>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="text-center">
            <g:savetoandroidpay :jwt="googlePayJwt" size="standard" theme="dark"></g:savetoandroidpay>
          </v-col>
          <v-col cols="12" class="text-center" v-if="isApplePayAvailable">
            <v-img :src="$i18n.locale === 'en' ? require('../../../assets/Add_to_Apple_Wallet_rgb_US-UK.svg') : require('../../../assets/Add_to_Apple_Wallet_rgb_HK.svg')"
                   width="169px"
                   class="apple-wallet-btn"
                   contain
                   @click="downloadApplePayPass"></v-img>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field :label="$t('my_account.sasv_status')"
                      readonly
                      hide-details
                      :value="sasvVerificationLabel"></v-text-field>
      </v-col>
      <v-col class="text-right" cols="12" md="6" v-if="canVerifySasv">
        <v-btn rounded
               :large="$vuetify.breakpoint.width>600"
               color="primary"
               @click="$router.push({name: 'sasv-verify'})"
               class="mt-9">
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          <span class="font-size-35">{{ $t('my_account.go_verify_sasv') }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field :label="$t('my_account.octopus_mapped_at')"
                      readonly
                      hide-details
                      :value="octopusMappedAtLabel"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field :label="$t('my_account.octopus_id')"
                      readonly
                      hide-details
                      :value="octopusNoLabel"></v-text-field>
      </v-col>
      <v-col class="text-right" cols="12" md="6">
        <v-btn icon
               :large="$vuetify.breakpoint.width>600"
               color="primary"
               @click="showAccMapOctopusModal = true">
          <v-icon>fas fa-info-circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <v-text-field :label="$t('my_account.acc_membership_valid_until')"
                      readonly
                      hide-details
                      :value="accMembershipValidUntilLabel"></v-text-field>
      </v-col>
      <v-col class="text-right" cols="12" md="6" v-if="canBuyAccMembership">
        <v-btn rounded
               :large="$vuetify.breakpoint.width>600"
               color="primary"
               @click="beforeAccMembershipPayment">
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          <span class="font-size-35">{{ $t('pay') }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row v-if="!editing">
      <v-col>
        <v-btn rounded
               :large="$vuetify.breakpoint.width>600"
               color="primary"
               class="m-2"
               @click="changePassword">
          <v-icon>mdi-lock-outline</v-icon>
          <span class="font-size-35">{{ $t('my_account.change_password') }}</span>
        </v-btn>
        <v-btn rounded
               :large="$vuetify.breakpoint.width>600"
               dark
               color="grey"
               @click="logout"
               class="m-2">
          <v-icon>mdi-exit-to-app</v-icon>
          <span class="font-size-35">{{ $t('header.logout') }}</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="showAccMembershipBeforePay" content-class="acc-info-modal">
      <AccMembershipBeforePay></AccMembershipBeforePay>
    </v-dialog>

    <v-dialog v-model="showAccMapOctopusModal"
              width="360"
              content-class="octopus-privilege">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row class="mt-4">
            <v-col cols="12">
              - {{ $t('my_account.octopus_privilege1') }}
              <v-icon color="green">fas fa-check</v-icon>
            </v-col>
            <v-col cols="12">
              - {{ $t('my_account.octopus_privilege2') }}
              <v-icon color="green">fas fa-check</v-icon>
            </v-col>
            <v-col cols="12">
              - {{ $t('my_account.octopus_privilege3') }}
              <v-icon color="green"
                      v-if="accMembershipValid">fas fa-check
              </v-icon>
              <v-icon color="red"
                      v-else>fas fa-times
              </v-icon>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <b-modal id="accountInfoQrCodeModal"
             size="xl"
             centered
             hide-footer>
      <b-container>
        <v-row>
          <v-col class="text-center">
            <qrcode :value="currentUser.token" :options="{ width: '10rem' }" class="account-info-membership-big-qrcode"></qrcode>
          </v-col>
        </v-row>
      </b-container>
    </b-modal>
  </v-container>
</template>

<script>
import {DateTime} from 'luxon'
import AccMembershipBeforePay from "../AccBooking/AccMembershipBeforePay";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import HkiaraceChangeEmailModal from "@/components/hkiarace/HkiaraceChangeEmailModal";

export default {
  name: 'AccountInfo',
  components: {AccMembershipBeforePay},
  setup(props, {root}) {
    const currentUser = computed(() => root.$store.state.user);
    watch(() => currentUser.value, (newVal) => {
      if (!newVal || !newVal.id) {
        root.$router.replace({name: 'home'})
      }
    })
    const editing = ref(false);

    const changeAccountEmail = async function () {
      const needRefresh = await root.$dialog.showAndWait(HkiaraceChangeEmailModal, {
        showClose: false,
        persistent: true,
      });

      if (needRefresh) {
        root.$storeDispatch('getMe');
      }
    }

    const googlePayJwt = ref(null);
    const loadSaveToGooglePay = function () {
      root.$callAPI('hkiarace/google_pay_pass/', {}, (response) => {
        googlePayJwt.value = response.body.jwt;

        const url = `https://apis.google.com/js/platform.js`;
        const $el = document.createElement('script');
        $el.src = url;
        $el.async = true;
        document.head.appendChild($el)
      })
    }

    const isApplePayAvailable = computed(() => !!window.ApplePaySession)
    const downloadApplePayPass = function () {
      root.$downloadFile('hkiarace/apple_pay_pass/', {}, 'pass.pkpass', 'application/vnd.apple.pkpass')
    };

    const sasvVerificationLabel = computed(() => {
      let sasv = currentUser.value.sasv;
      if (sasv) {
        return root.$t(`sasv_status.${sasv.status}`);
      }

      return root.$t('id_verification_status.not_verified');
    })
    const canVerifySasv = computed(() => {
      let sasv = currentUser.value.sasv;
      return !sasv || ['REJECTED', 'SUSPENDED'].indexOf(sasv.status) !== -1;
    })

    const showAccMapOctopusModal = ref(false);
    const showAccMembershipBeforePay = ref(false);


    onMounted(() => {
      root.$storeDispatch('getMe');

      setTimeout(loadSaveToGooglePay, 1)
    });

    return {
      currentUser,
      editing,
      changeAccountEmail,
      googlePayJwt,

      isApplePayAvailable,
      downloadApplePayPass,

      sasvVerificationLabel,
      canVerifySasv,
      showAccMapOctopusModal,
      showAccMembershipBeforePay,
    }
  },
  computed: {
    membershipValidUntil() {
      if (!this.currentUser.id_verified_at) {
        return false;
      }

      let validUntil = DateTime.fromISO(this.currentUser.id_verified_at).plus({days: 365});

      if (this.currentUser.id_type === 1) {
        let idExpiryDate = DateTime.fromISO(this.currentUser.id_expiry_date);

        if (idExpiryDate < validUntil) {
          validUntil = idExpiryDate;
        }
      }

      return validUntil;
    },
    membershipValidUntilLabel() {
      return this.membershipValidUntil ? this.membershipValidUntil.toFormat('yyyy/MM/dd') : '-';
    },
    octopusMappedAtLabel() {
      let sasv = this.currentUser.sasv;
      if (sasv && sasv.status === 'APPROVED') {
        return DateTime.fromISO(sasv.validated_at).toFormat('yyyy/MM/dd');
      }
      return '-';

      // return this.currentUser.octopus_mapped_at ? DateTime.fromISO(this.currentUser.octopus_mapped_at).toFormat('yyyy/MM/dd') : '-';
    },
    octopusNoLabel() {
      let sasv = this.currentUser.sasv;
      if (sasv) {
        return sasv.octopus_no;
      }
      return '-';
    },
    accMembershipValid() {
      if (!this.currentUser.acc_membership_valid_until) {
        return false;
      }

      return DateTime.fromISO(this.currentUser.acc_membership_valid_until) > DateTime.local();
    },
    canBuyAccMembership() {
      if (!this.currentUser.acc_membership_valid_until) {
        return true;
      }

      return DateTime.fromISO(this.currentUser.acc_membership_valid_until) < (DateTime.local().plus({days: 7}));
    },
    accMembershipValidUntilLabel() {
      if (!this.currentUser.acc_membership_valid_until) {
        return '-';
      }

      return this.accMembershipValid ? DateTime.fromISO(this.currentUser.acc_membership_valid_until).minus({'seconds': 1}).toFormat('yyyy/MM/dd') : this.$t('my_account.acc_membership_expired');
    },
  },
  methods: {
    showQrCode() {
      this.refreshToken();
      this.$bvModal.show('accountInfoQrCodeModal');
    },
    refreshToken() {
      this.$storeDispatch('getMe');
    },
    beforeAccMembershipPayment() {
      if (this.currentUser.octopus_id) {
        this.showAccMembershipBeforePay = true;
      } else {
        this.$showAlertMessage(this.$t('octopus_not_mapped'), () => {
          this.showAccMapOctopusModel = true;
        });
      }
    },
    postForm(path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      this.$startLoading();
    },
    changePassword() {
      this.$router.push({name: 'change-password'})
    },
    logout() {
      if (confirm(this.$t('logout_msg'))) {
        this.$storeDispatch('logout');
      }
    },
    saveInfo() {
      let params = {
        mobile: this.currentUser.mobile,

        salutation: this.currentUser.salutation,
        surname_en: this.currentUser.surname_en,
        given_name_en: this.currentUser.given_name_en,
        surname_zh: this.currentUser.surname_zh,
        given_name_zh: this.currentUser.given_name_zh,
      };

      this.$callAPI('hkiarace/edit_account_info/', params, function (response) {
        this.$showAlertMessage(this.$t('my_account.info_saved'));
        this.$storeDispatch('getMe');
        this.editing = false;
      }, function (response) {
        this.$showAlertMessage(this.$t('my_account.incorrect_password'));
      });
      this.password = null;
    },
    onReceivePromotionalEmailInput(value) {
      this.$callAPI('hkiarace/set_receive_promotional_email/', {
        receive_promotional_email: value,
      });
    },
  }
}
</script>

<style lang="less">
.account-info {
  padding: 32px;
  text-align: left;

  label {
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
    font-size: 1.2rem;
  }

  .apple-wallet-btn {
    margin: auto;
    cursor: pointer;
  }

  .account-info-title {
    font-size: 1.5rem;
    padding: 5px 0;
  }

  legend {
    color: rgb(202, 196, 196);
  }

  .v-label {
    color: #8E765B;
  }

  .v-text-field > .v-input__control > .v-input__slot:before {
    display: none;
  }

  .v-text-field > .v-input__control > .v-input__slot:after {
    display: none;
  }

  .account-info-edit-btn {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .account-info-membership-card-container {
    /*height: 162px;*/
    text-align: center;
    margin: auto;

    .account-info-membership-card {
      border-radius: 10px;
      width: 100%;
    }

    .account-info-membership-card-title {
      position: absolute;
      top: 22px;
      right: 25px;
      font-size: 2rem;
      color: white;
    }

    .account-info-membership-qrcode {
      background-color: white;
      text-align: center;
      /*position: absolute;*/
      /*bottom: 1.2rem;*/
      /*right: 1.2rem;*/
      /*height: 30rem !important;*/
      /*width: 30rem !important;*/
    }

    .account-info-membership-card-info {
      color: white;
      position: absolute;
      bottom: 1rem;
      left: 28px;
      margin-bottom: 0;
    }

    .fa-sync {
      color: white;
      position: absolute;
      right: 5px;
      bottom: 5px;
    }
  }


  .row {
    margin-bottom: 1rem;
  }

  .col-form-label {

  }

  .form-control, .readonly-form-control {
    border-radius: 0;
    border: none;
    background-color: transparent;
    padding-left: 0;
    /*color: #008C93;*/
  }

  .account-info-change-password-btn, .account-info-verify-id-btn {
    width: 100%;
    background-color: #3b3a53;
    border-color: #3b3a53;
    color: white;
    font-weight: bold;

    &:hover {
      background-color: transparent;
      color: #3b3a53;
    }
  }

}


.account-info-membership-big-qrcode {
  /*width: 75% !important;*/
  /*max-height: 100% !important;*/
}

@media only screen and (min-width: 960px) {
  .account-info {
    .account-info-membership-card-container {
      .account-info-membership-card-title {
        font-size: 1rem !important;
      }

      .account-info-membership-qrcode {
        /*bottom: 1.2rem;*/
        /*right: 1.2rem;*/
        /*height: 30rem !important;*/
        /*width: 30rem !important;*/
      }

      .account-info-membership-card-info {
        font-size: 0.666666rem;
      }
    }
  }
}

.acc-info-modal {
  width: auto;
  min-width: 400px;
  max-width: 860px;
}

.octopus-privilege {
  .v-card__text {
    font-size: 120%;
    text-align: left;
  }
}
</style>
